export default function () {
    return {
        system: {
            tab: 'form',
            type: 'pay',
            action: 'add',
            IncomePaymentNumber: '',
            OutcomePaymentNumber: '',
            code: '',
            subAgent:false,
            reservationCenter:false,
            manager: '',
            createDate: '',
            PaySystemType: '',
            saveId: '',
            none: false,
        },
        form: {
            Id: 0,
            RegularPaymentId: 0,
            Name: '',
            NameLat: '',
            CertificateId: '',
            CertificateName: '',


            PaymentDirection: 0,
            PaymentOperationID: 0,
            RateArticleId: null,
            CategoryId: 0,
            PaymentTypeId: 0,
            CashId: 0,
            PaymentAccountId: 0,
            AccountNumber: '',

            ContragentType: 1,

            ContragentID: null,
            ContragentName: '',
            PartnerLegalEntityId: null,
            PartnerLegalEntityName: '',

            Sum: 0,
            BankCommission: 0,
            SumVat: 0,
            CurrencyId: 0,


            NeedToPayDate: '',
            AccountDate: '',
            CreatedDate: '',

            PaymentDate: '',
            DocumentNumber: '',
            PaymentFor: '',
            Comment: '',

            RegularPaymentTypeId: 0,
            dayMonth: 1,
            dayWeek: 1,
            dayYear: '',
            dayOne: '',
            NotificationsEndDate: '',
            AgreementCodes:[],
            AdditionalValues:[],
            addCashCheck: false,
            OnlineCashId: 0,
            BillProvideTypeId: 1,
        },
        options: {
            legals: [],
            RegularPaymentTypeId: [
                {
                    label: 'Ежемесячный',
                    value: 0,
                    day: '',
                },
                {
                    label: 'Еженедельный',
                    value: 1,
                    day: '',
                },
                {
                    label: 'Ежедневный',
                    value: 2,
                    day: '',
                },
                {
                    label: 'Ежегодный',
                    value: 3,
                    day: '',
                },
                {
                    label: 'Разовый',
                    value: 4,
                    day: '',
                },
            ],
            dayWeek: [
                {
                    label: 'Понедельник',
                    value: 1,
                },
                {
                    label: 'Вторник',
                    value: 2,
                },
                {
                    label: 'Среда',
                    value: 3,
                },
                {
                    label: 'Четверг',
                    value: 4,
                },
                {
                    label: 'Пятница',
                    value: 5,
                },
                {
                    label: 'Суббота',
                    value: 6,
                },
                {
                    label: 'Воскресенье',
                    value: 7,
                },
            ],
        },
        load:{
            data: true,
        },
    }
}
